export default __webpack_public_path__ + "static/media/bg-pos.9b654248.png";